import {
  UserDetailsService,
  IUser,
} from "./../userdetails/user-details.service";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class CapSMSMailService {
  private basUrl = environment.smsUrl;

  private fcmURL = "https://fcm.googleapis.com/fcm/send";
  public fcmKey =
    "AAAAzMsTlU4:APA91bGpzB6QwYqyNYCPumg2bz8Z7SSTya7AuqjP8JN-0-KCxBOzhwUJ0yD2XrF7riLfavPGFVouaJTjcG5THnFG3iiCGvHZMBSZpNjxyUKJGezs0frQYcQU9PvbasfHcr8iDI7qezWK";
  constructor(
    private httpClient: HttpClient,
    private userDetail: UserDetailsService
  ) {}

  sendMailandSMS(data: any, from: RequestType) {
    this.userDetail.getDetails(data.username).then((res) => {
      var mailObj: IEmailParam = {
        toEmail: res.email_address,
        mailSubject: this.constructMailSubject(data, res, from),
        mailContent: this.constructMailContent(data, res, from),
      };
      var smsObj: ISMSParam = {
        mobileNumber: res.employee_phone,
        message: this.constructSMS(data, res, from),
      };

      this.sendMail(mailObj);
      this.sendSMS(smsObj);
    });
  }

  constructSMS(reqData: any, userDetails: IUser, from: RequestType): string {
    let dateFormat = require("dateformat");
    var name = userDetails.name;
    var request_type = this.requestTypeContent(from);
    var request_status = reqData.request_status;
    var req_id = reqData.request_id;

    var sla_content = "";
    var sla_disclaimer = "";
    if (request_status == "ACKNOWLEDGED") {
      sla_content = reqData.comments[reqData.comments.length - 1].exdata;
      var slacreate_date = dateFormat(reqData.sla_date, "dd-mm-yyyy");
      // sla_disclaimer="DISCLAIMER: Timelines may vary subject to practical situation & condition of the issues, ";
    }

    return `Dear ${name}, your ${request_type} request - ${req_id} has been ${request_status}. SLA for resolving this request will complete ${slacreate_date}. ${sla_disclaimer} Please open RNconnect app and check the status.`;
    // return `Dear ${name}, your ${request_type} request - ${req_id} has been ${request_status}. ${sla_content}${sla_disclaimer} Please open RNconnect app and check the status.`;
  }

  private constructMailSubject(
    reqData: any,
    userDetails: IUser,
    from: RequestType
  ): string {
    var request_type = this.requestTypeContent(from);

    var req_id = reqData.request_id;
    var request_status = reqData.request_status;
    return `RNTBCI ${request_type} Request ${req_id} - ${request_status}`;
  }

  private requestTypeContent(from: RequestType) {
    var request_type = "";
    if (from == RequestType.CAR_REQUEST) {
      request_type = "Car Maintainance";
    } else if (from == RequestType.HOUSE_REQUEST) {
      request_type = "House Maintainance";
    } else if (from == RequestType.HOUSE_RELOCATION) {
      request_type = "House Relocation";
    } else if (from == RequestType.DRIVER_CONCERN) {
      request_type = "Driver Concern";
    }

    return request_type;
  }
  private constructMailContent(
    reqData: any,
    userDetails: IUser,
    from: RequestType
  ): string {
    var name = userDetails.name;
    var request_type = this.requestTypeContent(from);
    var request_status = reqData.request_status;
    var req_id = reqData.request_id;
    var user_req_content = "";
    var sla_content = "";
    var sla_disclaimer = "";

    if (from == RequestType.CAR_REQUEST) {
      var user_request = reqData.user_request;
      var user_text = reqData.user_text;
      var veh_reg_no = reqData.veh_reg_no.split("-")[0];
      var vehicle_Type = reqData.veh_reg_no.split("-")[1];
      user_req_content = `<li>User Request : ${user_request}</li>
      <li>User's Description : ${user_text}</li>
      <li>Vehicle registration Number:<strong>${veh_reg_no}</strong></li>
      <li>Vehicle type : <strong>${vehicle_Type}</strong></li>`;
    } else if (from == RequestType.DRIVER_CONCERN) {
      var user_request = reqData.concern_type;
      var user_text = reqData.user_text;
      user_req_content = `<li>User Concenrs : ${user_request}</li>
      <li>User's Description : ${user_text}</li>`;
    } else if (from == RequestType.HOUSE_REQUEST) {
      var user_request = reqData.user_request;
      var user_text = reqData.user_text;
      user_req_content = `<li>User Request : ${user_request}</li>
      <li>User's Description : ${user_text}</li>`;
    }
    let dateFormat = require("dateformat");
    var status = reqData.comments[reqData.comments.length - 1].status;
    var admin_comment = reqData.comments[reqData.comments.length - 1].des;
    var sla_date = reqData.comments[reqData.comments.length - 1].date;
    var slacreate_date = dateFormat(reqData.sla_date, "dd-mm-yyyy");

    if (request_status == "ACKNOWLEDGED") {
      sla_content = reqData.comments[reqData.comments.length - 1].exdata;
      // sla_disclaimer="<p><strong>Disclaimer:</strong> Timelines may vary subject to practical situation & condition of the issues</p>";
    }

    return `<html>

    <head>
        <title>Grievance Details has been given to you</title>
    </head>

    <body>
        <div>
            <p>Dear ${name},</p>
            <p>${request_type} Request has been <strong>${request_status}</strong>, Please find the details below.</p>
            <ul>
                <li>Request Id: <strong>${req_id}</strong></li>
                 ${user_req_content}
                <li>Status : ${status}</li>
                <li>Admin's Comments : <strong>${admin_comment}</strong></li>

            </ul>

            <p>SLA for resolving this request will complete ${slacreate_date}. DISCLAIMER: Timelines may vary subject to practical situation & condition of the issues.</p>
            <p>Please open RNconnect app and check the status. This is a system generated e-mail, please do not reply.</p>
            Regards,<br />
            Admin team<br />
        </div>
    </body>

    </html>`;
  }

  private sendMail(data: IEmailParam) {
    this.httpClient.post(this.basUrl + "/sendMail/", data).subscribe((res) => {
      console.log("sendMail", res);
    });
  }

  private sendSMS(data: ISMSParam) {
    this.httpClient.post(this.basUrl + "/sendSMS/", data).subscribe((res) => {
      console.log("sendSMS", res);
    });
  }

  public pushNotificationFCM(data) {
    // let header = new HttpHeaders().set("Authorization", "key=" + this.fcmKey);
    // this.httpClient
    //   .post(this.fcmURL, data, { headers: header })
    //   .subscribe((res) => {
    //     console.log("PUSH-NOTIFINCATION-SUCCESS", res);
    //   });

    this.httpClient.post(this.basUrl + '/notification', data).subscribe((res) => {
      console.log("notification send successfully", res);
    }, (error) => {
      console.log("Error occure during the notification send", error);
    });
  }
}

export interface IEmailParam {
  toEmail: string;
  mailSubject: string;
  mailContent: string;
  ccEmail?: string;
  bccEmail?: string;
}
export interface ISMSParam {
  mobileNumber: string;
  message: string;
}

export enum RequestType {
  CAR_REQUEST = 1,
  HOUSE_REQUEST = 2,
  HOUSE_RELOCATION = 3,
  DRIVER_CONCERN = 4,
}
